import { Grid, Skeleton, Typography, useTheme } from '@mui/material'
import { ReactNode } from 'react'
import { TriangleDecrIcon, TriangleIncrIcon } from 'src/assets/icons'

import { FONTS, SPACES } from 'src/constants'

interface IGlobalStatisticItem {
  icon: () => JSX.Element
  count?: number
  title: string | ReactNode
  change?: number
}

const GlobalStatisticItem = ({ icon, count, title, change }: IGlobalStatisticItem) => {
  const theme = useTheme()

  return (
    <Grid
      item
      container
      width={'16%'}
      minWidth={'10rem'}
      minHeight={'4.7rem'}
      alignItems="center"
      pl={SPACES.xxl}
      sx={{ backgroundColor: theme.palette.custom.secondary, borderRadius: 5 }}
    >
      <Grid
        item
        width={'2.5rem'}
        height={'2.5rem'}
        style={{ borderRadius: '50%', backgroundColor: theme.palette.custom.white }}
        display={'flex'}
        alignItems="center"
        justifyContent={'center'}
        mr={SPACES.xs}
      >
        {icon()}
      </Grid>
      <Grid item>
        {Number.isInteger(count) ? (
          <div style={{ marginBottom: 4, display: 'flex', gap: 10 }}>
            <Typography
              color={theme.palette.custom.darkBlue2}
              fontSize={FONTS.SIZES.m}
              fontWeight={FONTS.WEIGHTS.bold}
            >
              {count}
            </Typography>
            {typeof change === 'number' && (
              <Typography
                color={change >= 0 ? theme.palette.custom.primary : theme.palette.custom.warning2}
                fontSize={FONTS.SIZES.m}
                fontWeight={FONTS.WEIGHTS.bold}
              >
                {change >= 0 ? <TriangleIncrIcon /> : <TriangleDecrIcon />}
                {Math.abs(change)}%
              </Typography>
            )}
          </div>
        ) : (
          <Skeleton variant="text" sx={{ fontSize: FONTS.SIZES.m, mb: '0.25rem' }} />
        )}
        <Typography
          color={theme.palette.custom.grey2}
          fontSize={FONTS.SIZES.xs}
          fontWeight={FONTS.WEIGHTS.normal}
        >
          {title}
        </Typography>
      </Grid>
    </Grid>
  )
}

export { GlobalStatisticItem }
